<template>
  <Layout class="main" style="height: 100%">
    <Header>
      <header-bar />
    </Header>
    <Content class="main-content-con"><router-view /></Content>
  </Layout>
</template>

<script>
import HeaderBar from "./components/header-bar";
import User from "./components/user";
export default {
  name: "Main",

  components: { HeaderBar, User },

  data() {
    return {
      headerTitle: "应用平台",
    };
  },
};
</script>

<style lang="less" scoped>
.ivu-layout-header {
  background: #fff;
  padding: 0;
}

.main {
  overflow: scroll;
  .header-title {
    width: 120px;
    height: 42px;
    font-size: 30px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #333333;
    line-height: 42px;
  }
  .main-content-con {
    position: relative;
    height: ~"calc(100vh - 64px)";
    padding: 0;
    overflow: scroll;
  }
}

.main-modal {
  .send-btn {
    width: 120px;
    color: #666;
    background: #eee;
    border-color: transparent;
  }

  .primary-btn {
    background: linear-gradient(153deg, #975eec 0%, #623ea5 100%) !important;
    color: #fff;
    &:hover,
    &:active {
      border-color: #975eec !important;
    }
  }

  .default-btn {
    &:hover {
      color: #515a6e;
      border-color: #fff;
    }
  }
}
</style>